export default "__VITE_ASSET__CO$D0sB4__"